import builder from '../builder';
import CommonFileDoubleAlternate from '../../streamline-icons/bold/common-file-double-alternate.svg';

export default builder(
  'IconCommonFileDoubleAlternateBold',
  CommonFileDoubleAlternate,
);
